<script>
    import config from '../libs/config.js';

    import _ from 'lodash'
    import AOS from 'aos'
    import 'aos/dist/aos.css'

    import func from '../libs/functions.js';
    import _system from '../libs/system'

    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: "leanView",
        data(){
            return {
                loaded: false,
                notification: false
            }
        },
        computed: {},
        methods : {},
        created(){
            AOS.init();
  

        }
    }
    
</script>



<template>
<span>
                <slot />
    </span>
</template>
<style>

</style>



// WEBPACK FOOTER //
// src/layouts/leanView.vue